import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { motion } from "framer-motion";

const MessagePage = () => {
  const [searchParams] = useSearchParams();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const title = searchParams.get("title");
    const fullMessage = searchParams.get("message");
    console.log(title);

    if (fullMessage) {
      setMessage(decodeURIComponent(fullMessage));
    }
    if (title) {
      setTitle(decodeURIComponent(title));
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white shadow-lg rounded-2xl p-6 w-96 text-center">
        <h1 className="text-2xl font-semibold text-gray-800">{title}</h1>
        <p className="mt-4 text-gray-600 text-lg">
          {message || "No message found"}
        </p>
      </motion.div>
    </div>
  );
};

export default MessagePage;
